/**
 * Body timeline block.
 * @module components/ItaliaTheme/Blocks/Timeline/Body
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'design-react-kit/dist/design-react-kit';
import { injectLazyLibs } from '@plone/volto/helpers/Loadable/Loadable';
import cx from 'classnames';

/**
 * View Timeline body class
 * @class Body
 * @extends Component
 */
const Body = ({ data, children, nItems = 0, reactSlick }) => {
  const bgColor = data.bg_color || 'secondary';

  const Slider = reactSlick.default;

  const NextArrow = ({ onClick, currentSlide, slideCount }) => (
    <button
      className={cx(
        'custom-arrow',
        'next-arrow',
        bgColor === 'primary' || bgColor === 'warning'
          ? 'custom-arrow-dark'
          : 'custom-arrow-light',
        currentSlide >= slideCount - settings.slidesToShow
          ? 'arrow-opacity'
          : '',
      )}
      onClick={onClick}
    >
      &gt;
    </button>
  );

  const PrevArrow = ({ onClick, currentSlide }) => (
    <button
      className={cx(
        'custom-arrow',
        'prev-arrow',
        bgColor === 'primary' || bgColor === 'warning'
          ? 'custom-arrow-dark'
          : 'custom-arrow-light',
        currentSlide === 0 ? 'arrow-opacity' : '',
      )}
      onClick={onClick}
    >
      &lt;
    </button>
  );

  const settings = {
    infinite: false,
    speed: 500,
    slidesToShow: nItems < 3 ? nItems : 3,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div
      className={cx(
        'full-width py-5 h-100',
        bgColor ? 'bg-timeline-' + bgColor : '',
      )}
    >
      <div className="slider-container container px-4">
        {data?.title && <h2>{data.title}</h2>}
        <div className="it-carousel-all">
          <div
            className={cx(
              'line-wrapper',
              bgColor === 'primary' || bgColor === 'warning'
                ? 'line-wrapper-dark'
                : 'line-wrapper-light',
            )}
          ></div>
          <Slider {...settings}>{children}</Slider>
        </div>
      </div>
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
Body.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default injectLazyLibs(['reactSlick'])(Body);
